import { FC } from "react";
import { SecondarySearch } from "../../../Components";
import { FiltersBar, SortersBar } from "../components";
import { useHotelsListingContext } from "../context/HotelsListingContext";
import HotelList from "../components/HotelList/HotelList";
import { Hotel } from "src/store/apis/Hotels";
import SearchProgressBar from "src/Modules/Hotels/Components/SearchProgressBar/SearchProgressBar";
import CountdownTimerSlider from "../../../Components/CountdownTimerSlider/CountdownTimerSlider";

const HotelListingMobile: FC<{ fullDataGroups: any; filteredDataGroups: any; hotels: Hotel[] }> = ({ fullDataGroups, filteredDataGroups, hotels }) => {
  const { isPollingDone, hasFirstResults, searchObject } = useHotelsListingContext();
  const hasHotels = !isPollingDone || hotels.length > 0;
  return (
    <div className="flex flex-col items-center justify-center gap-4 bg-background-default">
      <div className="sticky top-0 z-30 flex w-full flex-col bg-background-default shadow-md rounded-b-sm">
        <div className="w-full">
          <div className="flex w-full flex-1 items-center justify-between gap-4 border-b border-border-default p-3">
            <div className="flex-1 flex-col">
              <SecondarySearch initialValues={searchObject} />
            </div>
          </div>
        </div>
        <div className="flex flex-col gap-3 pb-2">
          <div className="w-full">
            <CountdownTimerSlider />
          </div>
          {hasHotels && (
            <div className="w-full bg-background-default px-5">
              <div className="flex items-center justify-between gap-3 ">
                <div className="w-full">
                  <SortersBar dataGroups={filteredDataGroups} />
                </div>
                <div>
                  <FiltersBar dataGroups={fullDataGroups} />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      {hasFirstResults && <SearchProgressBar isPollingDone={isPollingDone} />}

      <div className="flex h-full w-full items-center justify-center p-3">
        <HotelList hotels={hotels} />
      </div>
    </div>
  );
};

export default HotelListingMobile;
